import { AlarmSeverities } from '../../../common/AlarmSeverities';
import { PropertyType } from '../../../models/enum';
import { ContextualField } from '../../../models/ContextualField';

export const AlarmSeverity: ContextualField = {
    modelName: 'alarmLevel',
    propertyType: PropertyType.Select,
    icon: 'fa-bell',
    label: 'Severity',
    propertyName: 'alarmLevelProperty',
    extraData: {
        options: AlarmSeverities
    }
};